import type { ReactNode } from 'react'

import { GradientBackdrop } from './gradient-backdrop'

type AuthLayoutProps = {
  children: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-white">
      <GradientBackdrop />

      <header className="absolute left-0 top-0 z-10 flex items-center px-8 py-6">
        <img src="/icons/logo-text.svg" alt="Doutor Sim" className="h-7 w-auto" />
      </header>

      <div className="relative flex min-h-screen w-full items-center justify-center px-4">
        {children}
      </div>
    </div>
  )
}
